import { useEffect, useMemo } from 'react';
import { useOidcAccessToken } from '@axa-fr/react-oidc';
import type { OidcAccessToken } from '@axa-fr/react-oidc/dist/ReactOidc';
import jwtDecode from 'jwt-decode';

export default (): OidcAccessToken => {
  const { accessToken, ...oidc } = useOidcAccessToken();

  const tokenExpired = useMemo(() => {
    const decodedToken = accessToken ? jwtDecode(accessToken) : false;

    if (decodedToken) {
      return (decodedToken as { exp: number })?.exp < Date.now() / 1000;
    }
    return false;
  }, [accessToken]);

  useEffect(() => {
    if (tokenExpired) {
      localStorage.clear();
      window.location.reload();
    }
  }, [tokenExpired]);

  return { accessToken, ...oidc };
};
